export default __webpack_public_path__ + "9398ea35efe08e5a949beccd6045ef5e.jpg";